<script setup lang="ts">
import type { Props } from '@autobid/ui/types/components/CardColumnsGroup'
import WebComponent from './CardColumnsGroupApp.vue'
import PdfComponent from './CardColumnsGroupPdf.vue'

const props = defineProps<Props>()

const isPdfPage = inject('isPdfPage', false)
</script>

<template>
  <PdfComponent v-if="isPdfPage" v-bind="props" />
  <WebComponent v-else v-bind="props" />
</template>
